<template>
    <div>
      <head-top :navActive="navActive"></head-top>
      <!-- 内容 start -->
      <div class="description-first-bg"></div>
      <div class="fqa-main">
        <div class="fqa-main-link">
          <a :href="'#'+item.id" v-for="item in innerHtmlList">{{item.title}}</a>
        </div>
        <div class="fqa-main-link-inner">
          <div class="link-inner-div" v-for="item in innerHtmlList" :id="item.id">
            <h3><i></i>{{item.title}}</h3>
            <div v-html="item.content"></div>
          </div>
        </div>
      </div>
      <!-- 内容 end -->
      <foot-bottom></foot-bottom>
    </div>
</template>

<script>
  import headTop from '../components/header/head-top'
  import footBottom from '../components/footer/foot-bottom'
  import tool from '../assets/js/tool.js'
  export default {
    name: "description-second",
    data () {
      return {
        navActive: 1,
        innerHtmlList: '', //接收数据数组
      }
    },
    components: {
      headTop,
      footBottom,
    },
    methods: {
      linkFun (url) {
        this.$router.push({
          path: url,
        })
      }
    },
    mounted () {
      let data = {
        type: 2,
        category_id: this.$route.query.id
      };
      tool.postData('get_system_list',data,(res) => {
        this.innerHtmlList = res.data.data.information_list;
      });
    }
  }
</script>

<style scoped lang="scss">
  @import "../assets/style/common";
  .description-first-bg{
    width: 100%;
    height: 80px;
    background: url("../../static/img/nav.png");
  }
  .fqa-main{
    width: $box-width;
    background-color: #fff;
    margin: 0 auto;
    padding-top: 45px;
    box-sizing: border-box;
    .fqa-main-link{
      border-bottom: 1px solid #c4d2f4;
      a{
        display: block;
        @include font(20px,#666);
        margin-bottom: 20px;
        &:hover{
          text-decoration: underline;
          color: #3b6bda;
        }
      }
    }
    .fqa-main-link-inner{
      padding-bottom: 35px;
      .link-inner-div{
        h3{
          @include font(25px,#333);
          line-height: 82px;
          i{
            width: 10px;
            height: 10px;
            background-color: #3b6bda;
            display: inline-block;
            margin-right: 10px;
            vertical-align: middle;
          }
        }
        p{
          @include font(18px,#666);
          line-height: 25px;
          margin-bottom: 20px;
          a{
            color: #3b6bda;
            cursor: pointer;
          }
        }
        img{
          display: block;
          margin: 0 auto;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/description-third.vue